module.exports = __webpack_public_path__ + "media/img/about/main-banner-tab-bfcd08fedaac7b28926613c7ca4a9c34.png";